/**
 * @param {number|BigInt} value
 * @param {number} digits
 *
 * @return string
 */
export function formatDecimal(value, digits) {
  const format = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    useGrouping: true,
  })

  return format.format(value);
}
